<template>
<div v-if="sessions && sessions.length">
    <div v-if="layout == 'contentareafeed'" class='contentareafeed'>
        <div class='mx-3 my-0 px-0 sands-sq-body-background sq-body pt-0 mt-2'>
            <div v-if="topWidget" v-html="topWidget">
            </div>
            <div class='container-fluid___'>
                <div class='content-area-inner-container flex-wrap d-sm-flex flex-column flex-sm-row'>
                    <div v-for="(aSession, index) in sessions" :key="index" class='col col-sm-6 col-lg-4 my-1 border-bottom pb-2 d-flex flex-row flex-wrap sq-session-block sq-columns sq-six py-2'>
                        <div v-if="aSession && aSession.experts && aSession.experts.length" class='col-3 pl-0 sq-two sq-columns'>
                            <div class="sq-speakers-image-small">
                                <div class="sq-gdlr-session-thumbnail-wrapper sq-twelve sq-columns">
                                    <a :href="'/speaker/' + aSession.experts[0].slug + configuredLinkExtension" target="_blank">
                                        <img v-if="aSession.experts[0] && aSession.experts[0].avatarSquareSmall && aSession.experts[0].avatarSquareSmall.xx" class="w-100" :src="aSession.experts[0].avatarSquareSmall.xx">
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class='col-9 px-0 sq-ten sq-columns'>
                            <h3 v-if="aSession && aSession.name" class="sq-session-title sands-sq-session-title sq-columns sq-twelve mt-n1">
                                <a class="font-weight-bold h5 text-dark" :href="'/'+aSession.primaryTrack.slug+'/'+aSession.slugNames[0] + configuredLinkExtension" rel="bookmark" :title="aSession.name" target="_blank">
                                    {{aSession.name}}
                                </a>
                            </h3>
                            <div v-if="aSession && aSession.experts && aSession.experts.length" class="sq-speakers-name-and-company sq-column sq-twelve">
                                <a v-if="aSession.experts[0].forename && aSession.experts[0].surname" class="text-dark sands-sq-speakers-infos" :href="'/speaker/' + aSession.experts[0].slug + configuredLinkExtension" target="_blank">{{aSession.experts[0].forename}} {{aSession.experts[0].surname}}</a> (<em v-if="aSession.experts[0] && aSession.experts[0].company" class="sands-sq-speakers-infos">{{aSession.experts[0].company}}</em>)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="bottomWidget" v-html="bottomWidget">
            </div>
        </div>
    </div>
    <div v-else-if="layout == 'sidebarfeed'" class='sidebarfeed'>
        <div class='sq-body sands-sq-body-background'>
            <div v-if="topWidget" v-html="topWidget">
            </div>
            <div v-for="(aSession, index) in sessions" :key="index" class='sq-session-block sq-columns sq-twelve'>

                <div v-if="aSession && aSession.experts && aSession.experts.length" class="sq-two sq-columns">
                    <div v-if="aSession.experts[0] && aSession.experts[0].avatarSquareSmall" class="sq-speakers-image-small">
                        <div class="sq-gdlr-session-thumbnail-wrapper sq-twelve sq-columns"><a :href="'/speaker/' + aSession.experts[0].slug + configuredLinkExtension" target="_blank"></a>
                            <div class="gdlr-speaker-thumbnail"><a :href="'/speaker/' + aSession.experts[0].slug + configuredLinkExtension" target="_blank"><img v-if="aSession.experts[0] && aSession.experts[0].avatarSquareSmall && aSession.experts[0].avatarSquareSmall.xx" :src="aSession.experts[0].avatarSquareSmall.xx" width="150" height="150"></a><a class="gdlr-speaker-thumbnail-overlay-link" href=""><span class="gdlr-speaker-thumbnail-overlay"></span></a></div>
                        </div>
                    </div>
                </div>

                <div class="sq-ten sq-columns">
                    <h3 v-if="aSession && aSession.name" class="sq-session-title sands-sq-session-title sq-columns sq-twelve">
                        <a :href="'/'+aSession.primaryTrack.slug+'/'+aSession.slugNames[0] + configuredLinkExtension" rel="bookmark" :title="aSession.name" target="_blank">
                            {{aSession.name}} </a>
                    </h3>
                    <div v-if="aSession && aSession.experts && aSession.experts.length" class="sq-speakers-name-and-company sq-column sq-twelve">
                        <a v-if="aSession.experts[0].forename && aSession.experts[0].surname" class="sands-sq-speakers-infos" :href="'/speaker/' + aSession.experts[0].slug + configuredLinkExtension" target="_blank">{{aSession.experts[0].forename}} {{aSession.experts[0].surname}}</a> (<em v-if="aSession.experts[0] && aSession.experts[0].company" class="sands-sq-speakers-infos">{{aSession.experts[0].company}}</em>)
                    </div>
                </div>

            </div>
            <div v-if="bottomWidget" v-html="bottomWidget">
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'

export default {
    name: "IframeDisplay",
    data() {
        return {
            qualificationData: this.settingsPerm,
            seriesId: this.settingsPerm.seriesId,
            topWidget: this.settingsPerm.topWidget,
            bottomWidget: this.settingsPerm.bottomWidget,
            layout: this.settingsPerm.layout,
            qualificationSlug: this.settingsPerm.qualificationSlug,
            taxonomy: this.settingsPerm.taxonomy,
            qualificationId: this.settingsPerm.qualificationId,
            configuredLinkExtension:'',
            result: null,
            loading: true,
            error: true,
            brandId: this.settingsPerm.brandId,
            qualificationsFromCan: null,
            sessions: null,
        };
    },
    props: {
        settingsPerm: Object
    },
    setup() {

    },
    created() {
        if (this.seriesId && this.qualificationId) {
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: window.walkuere_app_data.concord_url,
            })
            provideApolloClient(apolloClient)

            let variables = {
                id: this.seriesId,
                qualificationIds_in: this.qualificationId.split(),
            };
            const {
                result
            } = useQuery(CONCORD_QUERIES.GET_SESSION_BY_QUALIFICATIONS, variables);
            watch(result, value => {
                if (value && value.vueSessions && value.vueSessions.Sessions && value.vueSessions.Sessions.length) {
                    this.sessions = value.vueSessions.Sessions;
                }
                setTimeout(function(){
                    let messageToParent = {
                    height:document.body.scrollHeight,
                    width:document.body.scrollWidth,
                    message_type: 'inner_iframe_initialized_or_changed',
                    layoutname: 'contentareafeed'
                    };
                    window.top.postMessage(messageToParent, '*');
                }, 200);
            })
        }
        if (this.settingsPerm && this.settingsPerm.configuredLinkExtension) {
            this.configuredLinkExtension = this.settingsPerm.configuredLinkExtension;
        }
    },
    methods: {},
};
</script>

<style>
.contentareafeed .sq-body {
    overflow: hidden !important;
    display: block;
    margin: 0 0 20px 0;
    padding: 10px 15px 20px 15px;
    font-family: "Montserrat";
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    border: 1px solid rgba(0, 0, 0, .1);
    background: #fff;
}

.contentareafeed .sq-body>li {
    list-style: none;
}

.contentareafeed .sq-session-title {
    text-transform: unset !important;
    letter-spacing: normal !important;
    line-height: 14px;
}

.contentareafeed .sq-session-title a {
    line-height: 12px;
    font-size: 14px;
}

.contentareafeed h3 a:hover {
    text-decoration: underline;
}

.contentareafeed .sq-speakers-name-and-company {
    font-size: 12px;
}

/* button*/
.contentareafeed li .button-link-to-website {
    padding: 10px 0;
    margin-top: 10px;
    display: inline-block;
}

.contentareafeed li .button-link-to-website a.button {
    text-decoration: none;
    background: transparent;
    color: #3ccbaa;
    border: 1px solid #3ccbaa;
    padding: 10px;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 700;
}

.contentareafeed li .button-link-to-website a.button:hover {
    text-decoration: underline;
    background: #3ccbaa;
    border: 1px solid #3ccbaa;
    color: #fff;
}

.sidebarfeed .sq-column,
.sidebarfeed .sq-columns {
    float: left;
    position: relative;
    min-height: 1px;
}

.sidebarfeed .sq-twelve {
    width: 100%;
}

.sidebarfeed .sq-eleven {
    width: 90%;
}

.sidebarfeed .sq-ten {
    width: 80%;
}

.sidebarfeed .sq-nine {
    width: 75%;
}

.sidebarfeed .sq-eight {
    width: 65%;
}

.sidebarfeed .sq-seven {
    width: 55%;
}

.sidebarfeed .sq-six {
    width: 50%;
}

.sidebarfeed .sq-five {
    width: 65%;
}

.sidebarfeed .sq-four {
    width: 33%;
    margin-right: 2%;
}

.sidebarfeed .sq-three {
    width: 23%;
    margin-right: 2%;
}

.sidebarfeed .sq-two {
    width: 17%;
    margin-right: 3%;
}

.sidebarfeed .sq-one {
    width: 8%;
    margin-right: 2%;
}

.sidebarfeed .sq-body {
    width: 320px;
    overflow: hidden !important;
    /* 	    background-color: #ecf4f7; */
    border-bottom-width: 1px;
    border-right-width: 1px #d4e7ec solid;
    border-bottom-style: solid;
    border-right-style: solid;
    display: block;
    margin: 0 0 20px 0;
    padding: 10px 15px 20px 15px;
    font-family: "Montserrat";
    min-width: 319px;
}

.sidebarfeed h3 {
    font-size: 14px;
    margin: 0 0 5px 0;
}

.sidebarfeed .sands-sq-session-title {
    background-color: transparent !important;
}

.sidebarfeed h3 a {
    color: #333;
    text-decoration: none;
    letter-spacing: 0;
}

.sidebarfeed h3 a:hover {
    text-decoration: underline;
}

.sidebarfeed .sq-body>li {
    list-style: none;
}

.sidebarfeed .conference-info-logo img {
    max-width: 100%;
}

.sidebarfeed .sq-session-block {
    border-bottom: dotted 1px #999;
    margin-top: 10px;
    padding-bottom: 10px;
}

.sidebarfeed .sq-gdlr-session-thumbnail-wrapper img {
    width: 100%;
    height: auto;
}

.sidebarfeed .sq-speakers-name-and-company a {
    text-decoration: none;
    font-size: 13px;
    /* 	    color:#08417B; */
}

.sidebarfeed .sq-speakers-name-and-company a:hover {
    text-decoration: underline;
}

.sidebarfeed .sq-speakers-name-and-company em {
    text-decoration: none;
    font-size: 12px;
}

.sidebarfeed li .button-link-to-website {
    padding: 10px 0;
    margin-top: 10px;
    display: inline-block;
}

.sidebarfeed li .button-link-to-website a.button {
    text-decoration: none;
    /* 		background:#a4c408; */
    padding: 10px;
    /* 		color: #fff; */
    border-radius: 3px;
    font-size: 14px;
    font-weight: 700;
}

.sidebarfeed li .button-link-to-website a.button:hover {
    text-decoration: underline;
}

.sq-body>li,
.widget_text {
    list-style: none;
}
</style>
